import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { getCurrentUser } from 'aws-amplify/auth';

// Who is signed in, for stamping a record with its author. Best effort: a
// mark without an author is still a mark, so a failed lookup resolves to
// undefined rather than blocking the save.
export const currentUsername = (): Observable<string | undefined> =>
    from(getCurrentUser()).pipe(
        map((user) => user.signInDetails?.loginId || user.username),
        catchError(() => of(undefined)),
    );
